<template>
  <view-container v-if="!user.isPartner">
    <v-card v-if="result.password">
      <v-card-title>Новый пароль</v-card-title>
      <v-card-text>
        <v-chip
          class="display-1 mt-4"
          large
          v-clipboard:copy="result.password"
          v-clipboard:success="onCopy"
        >
          {{ result.password }}
        </v-chip>
        <p v-if="result.expiresAt">
          Пароль можно использовать только один раз до
          {{ result.expiresAt | datetime }}
        </p>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="green"
          dark
          v-clipboard:copy="result.password"
          v-clipboard:success="onCopy"
        >
          Скопировать
        </v-btn>
        <v-btn text @click="close()">Закрыть</v-btn>
        <v-btn
          v-if="isNew"
          text
          color="primary"
          :to="{
            name: 'cashier-new',
            params: { clientId: cashier.clientId }
          }"
        >
          Новый кассир
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-form v-else>
      <v-card>
        <v-card-title>Доступ в приложение</v-card-title>
        <v-card-text>
          <v-switch label="постоянный пароль" v-model="passPermanent" />
          <p v-if="!passPermanent">
            Паролем можно воспользоваться только один раз в течение двух дней с
            момента генерации.
          </p>
        </v-card-text>
        <v-card-actions>
          <confirmation-dialog
            @confirm="generatePassword"
            title="Сгенерировать новый пароль?"
            text="Старый пароль перестанет действовать, мобильное приложение потребует повторную авторизацию."
            color="green darken-1"
            v-if="showConfirmation"
          >
            <template #activator="{ on }">
              <v-btn color="green" dark v-on="on">
                Сгенерировать новый пароль
              </v-btn>
            </template>
          </confirmation-dialog>
          <v-btn v-else color="green" dark @click="generatePassword">
            Сгенерировать пароль
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </view-container>
</template>
<script>
import ds from "@/datastore";
export default {
  name: "CashierAccess",
  props: {
    id: String,
    isNew: Boolean
  },
  data() {
    return {
      cashier: {},
      passPermanent: true,
      result: {},
      showConfirmation: !this.isNew
    };
  },
  computed: {
    user() {
      return this.$store.getters["auth/getUser"];
    }
  },
  deactivated() {
    this.$destroy();
  },
  async created() {
    this.cashier = await ds.find("cashier", this.id);
  },
  methods: {
    async generatePassword() {
      let resp = await this.cashier.resetPassword({
        passPermanent: this.passPermanent
      });
      this.result = resp.data;
      this.showConfirmation = true;
    },
    onCopy() {
      this.$store.commit(
        "notifications/success",
        "Пароль скопирован в буфер обмена"
      );
    },
    onCopyError() {
      this.$store.commit(
        "notifications/error",
        "Не удалось скопировать пароль"
      );
    },
    close() {
      this.result = {};
      this.$router.go(this.isNew ? -2 : -1);
    }
  }
};
</script>
